{"id":"Modal.FixedBottomPanel","prefabs":{"default":{"children":[{"component":"Modal.FixedBottomPanel","options":"options:*"}]}}}